import {
  AttachmentSearchQuery,
  IssuesAttachmentsSearchResponse,
  AppIssueBrief,
  AppIssueBriefSerialized,
} from '@playq/services-beetle';
import { GenericFailure, OffsetLimit } from '@playq/services-shared';
import { Filter } from '@playq/octopus-common';

import { IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { IBeetleId } from './types';
import { useAttachmentQueryBase } from './useBaseAttachmentsQuery';
import { issueAttachmentKeys } from './constants';

export const useSearchIssueAttachments = (
  query: AttachmentSearchQuery,
  iterator: OffsetLimit,
  filterBy: {
    [key: string]: Filter;
  } = {},
  options?: IUseQueryOptionsExtended<IssuesAttachmentsSearchResponse | undefined, GenericFailure | Error>
) => {
  return useAttachmentQueryBase<IssuesAttachmentsSearchResponse, AppIssueBrief, IBeetleId, AppIssueBriefSerialized>(
    issueAttachmentKeys,
    { iterator, filterBy },
    services2.audienceSupportService.searchIssuesByAttachments.bind(services2.audienceSupportService),
    query,
    (issueAttachment) => issueAttachment?.id,
    (response) => response.issues ?? [],
    (response, newEntities) => {
      response.issues = newEntities;
    },
    (prevResponse) => new IssuesAttachmentsSearchResponse(prevResponse.serialize()),
    (res) => res.serialize().issues,
    (newArray, updatedIterator) =>
      new IssuesAttachmentsSearchResponse({
        issues: newArray,
        iterator: updatedIterator,
      }),
    options
  );
};
